import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "CircleChevronRight.svg",
  "use": "CircleChevronRight.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"CircleChevronRight.svg\"><path d=\"M32,56A24,24,0,1,1,56,32,24,24,0,0,1,32,56Zm9.44-25.3975L30.4173,19.5981a2.0016,2.0016,0,0,0-2.8324,2.829l9.6063,9.59-9.6063,9.59a2.0016,2.0016,0,1,0,2.8324,2.8291L41.44,33.4316A1.9982,1.9982,0,0,0,41.44,30.6026Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol